import cloneDeep from 'lodash/cloneDeep';
import formMixin from '../../formMixin';
import parserTypesMixin from './typesMixin';
import get from 'lodash/get';
import isEqual from 'lodash/isEqual';
import set from 'lodash/set';
export default {
  name: 'NiotaClassicDevicetypesPacketParserTypeDefinitions',
  mixins: [formMixin, parserTypesMixin],
  props: {
    variables: {
      type: Object,
      required: false,
      default: () => ({})
    },
    custom: {
      type: Boolean,
      required: false,
      default: false
    },
    calculateElements: {
      type: Array,
      required: false,
      default: () => []
    },
    parseElements: {
      type: Array,
      required: false,
      default: () => []
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function () {
    return {
      variablesInternal: {}
    };
  },
  computed: {
    modeClass() {
      return this.UiTheme ? 'dark' : 'light';
    },
    variableTableHeaders() {
      return [{
        value: 'order',
        text: this.$i18n_t('NiotaClassic.DeviceTypes.form.parser.order'),
        sortable: false
      }, {
        value: 'name',
        text: this.$i18n_t('NiotaClassic.DeviceTypes.form.parser.targetVariable'),
        sortable: false
      }, {
        text: this.$i18n_t('NiotaClassic.DeviceTypes.form.parser.type'),
        sortable: false
      }
      // {
      //   text: this.$i18n_t('NiotaClassic.DeviceTypes.form.parser.layout'),
      //   sortable: false,
      // },
      ];
    },
    computedVariables() {
      let targetVars = [];
      if (this.custom) {
        const parserConfig = this.predefinedParserVars.find(parser => parser.id === this.custom);
        targetVars = Object.keys(parserConfig.fields).concat(this.calculateElements.map(e => e.target));
      } else {
        targetVars = this.parseElements.concat(this.calculateElements).map(e => e.target);
      }
      // do not show empty target variables
      targetVars = targetVars.filter(tv => tv !== '');
      const vars = this.variablesInternal;
      if (!vars) {
        return [];
      }

      // filter out variables which's target have been deleted
      const deletedTargets = Object.keys(vars).filter(v => targetVars.findIndex(tv => tv === v) === -1);
      deletedTargets.forEach(t => {
        delete vars[t];
      });
      let defVariables = Object.keys(vars).sort((a, b) => vars[a].order - vars[b].order);
      // update the indices of the order, in case targets have been deleted
      defVariables.forEach((t, i) => {
        vars[t].order = i;
      });
      // find new targets that have no mapping yet
      let newVars = targetVars.filter(v => defVariables.findIndex(dv => dv === v) === -1);
      if (newVars.length) {
        newVars.forEach(v => {
          vars[v] = {
            name: v,
            key: v,
            order: Object.keys(vars).length,
            type: 'auto'
          };
        });
        defVariables = Object.keys(vars).sort((a, b) => vars[a].order - vars[b].order);
      }
      return defVariables;
    }
  },
  watch: {
    variables: {
      handler: function (val) {
        this.variablesInternal = cloneDeep(val);
      },
      immediate: true
    },
    computedVariables: {
      handler: function (newVal, oldVal) {
        if (isEqual(newVal, oldVal)) {
          return;
        }
        this.emitChanges();
      },
      deep: true
    }
  },
  methods: {
    changeVariableOrder(variable, direction) {
      const vars = cloneDeep(this.variablesInternal);
      let currentIndex = vars[variable].order;
      let newIndex = Math.min(Object.keys(vars).length - 1, Math.max(0, currentIndex + (direction === 'up' ? -1 : 1)));
      if (newIndex !== currentIndex) {
        let otherVar = Object.keys(vars).find(v => vars[v].order === newIndex);
        vars[otherVar].order = currentIndex;
        vars[variable].order = newIndex;
      }
      this.variablesInternal = vars;
      this.emitChanges();
    },
    variableTypeSelected(variable) {
      const vars = cloneDeep(this.variablesInternal);
      const baseUnit = get(vars[variable], 'value_type.base_unit');
      if (baseUnit) {
        vars[variable].suffix = baseUnit;
      } else {
        delete vars[variable].suffix;
      }
      set(vars[variable], 'properties.unit', vars[variable]['value_type']['name']);
      this.variablesInternal = vars;
      this.emitChanges();
    },
    emitChanges() {
      const clonedVariables = cloneDeep(this.variablesInternal);
      if (isEqual(this.variables, clonedVariables)) {
        return;
      }
      this.$emit('variables-updated', clonedVariables);
    }
  }
};